import { render } from "./EnrichmentInitiativeVue.vue?vue&type=template&id=6d3f0df6"
import script from "./EnrichmentInitiativeVue.vue?vue&type=script&lang=js"
export * from "./EnrichmentInitiativeVue.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__